<template>
  <div>
    <section id="detail-info">
      <b-row v-show="!simulation && !simcon">
        <b-col cols="2">
          <energy :project_energy="projectEnergy"></energy>
        </b-col>
        <b-col cols="8">
          <b-row>
            <b-col cols="3">
              <!-- 设备 height 658px -->
              <equipment></equipment>
            </b-col>
            <!-- 综合信息 -->
            <b-col cols="6">
              <h1 class="text-center font-title">
                {{ projectInfo.project_name }}
              </h1>
              <p class="text-center">
                {{ projectInfo.project_en_name }}
              </p>
              <certificates></certificates>
              <div style="height: 427px; border-radius: 0.428rem; overflow: hidden" @click="simulation = true">
                <img src="./images/bg.png" alt="" style="width: 100%; height: 100%" />
              </div>
              <!-- <center :project_info="projectInfo"></center> -->
              <!-- <center-bottom :project_info="projectInfo"></center-bottom> -->
            </b-col>
            <b-col cols="3">
              <!-- 运维 height 658px -->
              <operation ref="operationRef" :project_operation="projectOperation"></operation>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <!-- <benchmarking></benchmarking> -->
              <prediction :project_prediction="projectOptimization"></prediction>
            </b-col>
            <b-col cols="6">
              <prediction1 :project_prediction="projectOptimization"></prediction1>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="2">
          <!-- 室外 height 180px -->
          <!-- <params-right :project_info="projectInfo" :project_params="projectParams.current"></params-right> -->
          <!-- 环境 height 792px -->
          <environment :project_params="projectParams" :project_info="projectInfo" :project_energy="projectEnergy"></environment>
        </b-col>
      </b-row>
      <div v-if="simulation && !simcon" class="position-absolute" style="width: 100%; height: 100%; background: transparent; z-index: 100">
        <Subsystems system="cold-source"></Subsystems>
      </div>
      <div
        v-show="simcon"
        class="position-absolute"
        style="top: 0; left: 0px; width: calc(100vw - 80px); height: 100vh; background: #f8f8f8; z-index: 100"
      >
        <div class="position-absolute" style="z-index: 2; top: 1rem; right: 1rem">
          <b-button class="btn-icon ml-1" variant="primary" size="sm" @click="closedialog">
            <feather-icon icon="XIcon" />
          </b-button>
        </div>
        <b-embed
          :src="'http://simcon.mtec.cc:81/'"
          allow-cross-origin
          allowfullscreen
          lazy
          aspect="4by3"
          type="iframe"
          style="width: 100%; height: 100%"
        ></b-embed>
      </div>
    </section>
    <div style="position: fixed; right: -4px; bottom: 45%; transform: translateY(-70px); display: flex; flex-direction: column; z-index: 9999">
      <b-button v-if="simulation && !simcon" variant="primary" size="sm" @click="simulation = false" class="custom_btn mb-1">
        <feather-icon icon="HomeIcon" />
      </b-button>
      <b-button v-if="!simcon" variant="primary" size="sm" title="开启仿真" @click="simcon = true" class="custom_btn">
        <b-icon icon="bezier2" aria-hidden="true" scale="1.2"></b-icon>
      </b-button>
    </div>
  </div>
</template>

<script>
import store from '@/store';
import { showToast } from '@/libs/utils/showToast';
import { computed, onMounted, reactive, toRefs, ref } from '@vue/composition-api';
import { momentJs } from '@/libs/utils/moment';
import ParamsRight from './components/ParamsRight.vue';
import ParamsLeft from './components/ParamsLeft.vue';
import Benchmarking from './components/Benchmarking.vue';
import Center from './components/Center.vue';
import CenterBottom from './components/CenterBottom';
import Energy from './components/Energy.vue';
import Environment from './components/Environment.vue';
import Equipment from './components/Equipment.vue';
import Operation from './components/Operation.vue';
import Prediction from './components/Prediction.vue';
import Prediction1 from './components/Prediction1.vue';
import Optimization from './components/Optimization';
import Certificates from './components/Certificates';
import { routerParams } from '@/libs/utils/routerParams';
import Subsystems from '@/views/front/jsf35/subsystems';

export default {
  name: 'ProjectDetail',
  components: {
    ParamsRight,
    ParamsLeft,
    Benchmarking,
    Center,
    Energy,
    Environment,
    Equipment,
    Operation,
    Prediction,
    Prediction1,
    Optimization,
    CenterBottom,
    Certificates,
    Subsystems,
  },
  setup() {
    const simulation = ref(false);
    const simcon = ref(false);
    const operationRef = ref(null);
    const event = reactive({
      project_id: computed(() => {
        return routerParams('project_id');
      }),
      projectInfo: computed(() => {
        return store.state.projects.selected;
      }),
      projectEnergy: {},
      projectParams: {
        current: {},
        list: {},
      },
      projectOperation: {
        alarm: [],
        inspection: [],
        repair: [],
        agent: [],
      },
      projectOptimization: {
        energy_list: [],
        prediction_list: [],
      },
    });
    const getProjectInfo = () => {
      const project_id = event.project_id;
      store
        .dispatch('projects/fetchProject', 7)
        .then((response) => {
          event.projectInfo = response.data;
          console.log('who--------------------');
        })
        .catch((error) => {
          showToast(error);
        });
    };

    const getProjectEnergy = () => {
      const project_id = event.project_id;
      store
        .dispatch('projects/fetchProjectEnergy', 7)
        .then((response) => {
          event.projectEnergy = response.data;
        })
        .catch((error) => {
          showToast(error);
        });
    };

    const getProjectParams = () => {
      const project_id = event.project_id;
      store
        .dispatch('projects/fetchProjectParams', 7)
        .then((response) => {
          event.projectParams = response.data;
        })
        .catch((error) => {
          showToast(error);
        });
    };

    const getProjectOperation = () => {
      const project_id = event.project_id;
      store
        .dispatch('projects/fetchProjectOperation', 7)
        .then((response) => {
          event.projectOperation = response.data;
        })
        .catch((error) => {
          showToast(error);
        });
    };

    const getProjectOptimization = () => {
      const project_id = event.project_id;
      store
        .dispatch('projects/fetchProjectOptimization', 7)
        .then((response) => {
          console.log('OptimizationData', response.data);
          event.projectOptimization = response.data;
        })
        .catch((error) => {
          showToast(error);
        });
    };
    const closedialog = () => {
			simcon.value = false;
			operationRef.value.fetchGetParams()
    };

    onMounted(() => {
      getProjectEnergy();
      getProjectParams();
      getProjectOperation();
      setTimeout(() => {
        // getProjectInfo();
        getProjectOptimization();
      }, 2000);
    });
    return {
      simulation,
      simcon,
      operationRef,
      ...toRefs(event),
      momentJs,
      closedialog,
    };
  },
};
/* eslint-disable global-require */
</script>

<style lang="scss" scoped>
.custom_btn {
  width: 42px;
  height: 38px;
  padding: 0.486rem 0.5rem;
}
.dark-layout .nav-tabs .nav-item .nav-link.active,
.dark-layout .nav-pills .nav-item .nav-link.active,
.dark-layout .nav-tabs.nav-justified .nav-item .nav-link.active {
  background: transparent !important;
}

.headerTitle {
  position: absolute;
  z-index: 999;
  top: 2rem;
  left: 50%;
  transform: translateX(-50%);
  width: 40rem;
  border-bottom-right-radius: 2rem;
  border-bottom-left-radius: 2rem;
  box-shadow: none !important;
  border-bottom: 2px solid rgba(158, 158, 158, 0.5);

  .dark-layout & {
    border-bottom: 2px solid rgba(24, 144, 255, 0.5);
  }
}
</style>
